// extracted by mini-css-extract-plugin
export default {"wrapper":"X3-z","play":"Y3-z"};